import { render, staticRenderFns } from "./specifyGoodsAssign.vue?vue&type=template&id=5e1a483c"
import script from "./specifyGoodsAssign.vue?vue&type=script&lang=js"
export * from "./specifyGoodsAssign.vue?vue&type=script&lang=js"
import style0 from "./specifyGoodsAssign.vue?vue&type=style&index=0&id=5e1a483c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports